import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Computer } from 'src/app/models/computer';
import { LanguageService } from 'src/app/services/account/language.service';
import { NavigationPlanRowComponent } from '../navigation-plan-row/navigation-plan-row.component';

@Component({
  standalone: true,
  selector: 'app-navigation-plan-normal-state',
  templateUrl: './navigation-plan-normal-state.component.html',
  styleUrls: ['./navigation-plan-normal-state.component.scss'],
  imports: [CommonModule, NavigationPlanRowComponent]
})
export class NavigationPlanNormalStateComponent {
  @Input() hudBottomOpened: boolean = false;
  @Input() isDragging: boolean = false;
  @Input() computersArray: Computer[] = [];
  @Input() cannotSkipMoreChargingStation: boolean = false;

  @Output() skipWaypointClick = new EventEmitter<void>();
  @Output() skipChargingStationClick = new EventEmitter<void>();
  @Output() stopNavigationClick = new EventEmitter<void>();
  @Output() batteryReservedWarningClick = new EventEmitter<void>();

  constructor(public languageService: LanguageService) {}

  public get closedComputer(): Computer | null {
    return this.computersArray.length > 0 ? this.computersArray[0] : null;
  }

  public onSkipWaypoint(): void {
    this.skipWaypointClick.emit();
  }

  public onSkipChargingStation(): void {
    this.skipChargingStationClick.emit();
  }

  public onStopNavigation(): void {
    this.stopNavigationClick.emit();
  }

  public onBatteryReservedWarning(): void {
    this.batteryReservedWarningClick.emit();
  }
}
